import {StyleSheet} from 'react-native';

import {cloudLight, darkGray, taupe, white} from '/theme/color/on.color';

export const TAB_BAR_HEIGH = 70;

export const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  base: {},
  tabBar: {
    backgroundColor: white,
    borderTopWidth: 1,
    borderTopColor: cloudLight,
    height: TAB_BAR_HEIGH,
  },
  tabBarTab: {
    flexDirection: 'column',
    marginTop: 6,
    marginBottom: 14,
    flex: 0,
    flexGrow: 1,
  },
  tabBarTabIconContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    paddingTop: 8,
    width: '100%',
  },
  tabBarTabIcon: {
    color: darkGray,
  },
  tabBarTabText: {
    fontSize: 12,
    lineHeight: 14,
  },
  tabBarTabLabelContainer: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  tabBarTabIndicator: {
    marginTop: 2,
    width: 14,
    height: 3,
    borderRadius: 2,
    backgroundColor: taupe,
  },
  tabBarTabActiveBar: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: 3,
    zIndex: 1,
    backgroundColor: taupe,
    borderRadius: 2,
  },
});
